'use client'

import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Checkbox,
    Stack,
    Button,
    Heading,
    Text,
    Link,
    useToast,
    useColorModeValue,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
} from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getAuthErrorMessage } from '../utils/authErrors';

export default function LoginCard() {
    const [email, setEmail] = useState("")
    const [recoveryEmail, setRecoveryEmail] = useState("")
    const [password, setPassword] = useState("")
    const [isLoggingIn, setIsLoggingIn] = useState("")

    const navigate = useNavigate();

    const { isOpen, onOpen, onClose } = useDisclosure()

    const toast = useToast()
    useEffect(() => {
        const auth = getAuth();
        console.log("auth", auth)
        if (auth.currentUser != null) {
            console.log("Should navigate")
            navigate("/");
        }
        onAuthStateChanged(auth, (user) => {
            if (user) {
                if (auth.currentUser != null) {
                    console.log("Should navigate")
                    navigate("/");
                }
            }
        });
    }, [])

    const doLogin = () => {
        setIsLoggingIn(true)
        const auth = getAuth();
        console.log("auth", auth, email, password)
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                console.log("signed in")
                const user = userCredential.user;
                // do routing here
                setIsLoggingIn(false)
                navigate("/");
            })
            .catch((error) => {
                setIsLoggingIn(false)
                toast({
                    title: 'Error logging in.',
                    description: getAuthErrorMessage(error),
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            });
    }

    const doEmailRecovery = () => {
        const auth = getAuth();
        sendPasswordResetEmail(auth, recoveryEmail)
            .then(() => {
                toast({
                    title: 'Password recovery email sent',
                    description: "Please check your email inbox for instructions to recover your account.",
                    status: 'success',
                    duration: 30000,
                    isClosable: true,
                })
                // close modal here
                onClose();
            })
            .catch((error) => {
                toast({
                    title: 'Error sending recovery email.',
                    description: getAuthErrorMessage(error),
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            });
    }

    return (
        <>


            <FormControl id="email">
                <FormLabel>Email address</FormLabel>
                <Input type="email" onChange={(e) => { setEmail(e.target.value) }} />
            </FormControl>
            <FormControl id="password">

                <Stack
                    direction={{ base: 'column', sm: 'row' }}
                    align={'end'}
                    justify={'space-between'}
                >
                    <FormLabel>Password</FormLabel>
                    <Text pb={2} align={'center'} fontSize={'0.91rem'}>
                        <Link color={'orange.400'} onClick={onOpen}>Forgot password?</Link>
                    </Text>
                </Stack>
                <Input type="password" onChange={(e) => { setPassword(e.target.value) }} onKeyDown={(e) => { if (e.key === 'Enter') doLogin(); }} />

            </FormControl>
            <Button
                bg={'orange.500'}
                onClick={doLogin}
                color={'white'}
                isLoading={isLoggingIn}
                loadingText='Logging In...'
                _hover={{
                    bg: 'orange.600',
                }}>
                Login
            </Button>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Recover Password</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormControl id="recoveryemail">
                            <FormLabel>Email address</FormLabel>
                            <Input type="email" onChange={(e) => { setRecoveryEmail(e.target.value) }} />
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='orange' mr={3} onClick={doEmailRecovery}>
                            Send Password Recovery
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}